module.exports = "/_next/static/images/CustomerDataFoundation-8cf3032d4c563dc0a3394f695bcdbf01.webp";